import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import axios from "axios";
import s from "./CampaignView.module.scss";
import {Helmet} from "react-helmet-async";
import {Aside} from "../../components/Aside/Aside";
import titleImage from "../../assets/images/titleImage.png";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import LoadingInside from "../../components/Loading/LoadingInside";

const API_URL = process.env.REACT_APP_API_LOCAL_URL;

const BlogView = () => {
    const {id} = useParams();

    const [campaign, setCampaign] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCampaign();
    }, [id]);

    const decodeBase64 = (str) => {
        try {
            return str ? atob(str) : "";
        } catch {
            return "";
        }
    };

    const fetchCampaign = async () => {
        try {
            const res = await axios.get(`${API_URL}blog/${id}`);
            setCampaign(res.data.data || res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <LoadingInside height={"90vh"}/>;
    if (!campaign) return <div>Campaign not found</div>;

    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: "Blogs", link: "/blogs"},
        {name: campaign.title}
    ];

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("ja-JP");
    };
    return (

        <>
            <Helmet>
                <title>{campaign.name}</title>
                <meta property="og:title" content={campaign.title}/>
                <meta property="og:image" content={campaign.featured_image}/>
                <meta
                    property="og:url"
                    content={`${process.env.REACT_APP_URL}/blog/${campaign.slug}`}
                />
                <meta name="description" content={campaign.title}/>
            </Helmet>
            <div className={"row mt-3"}>
                <div className={"col-12"}>
                    <Breadcrumb items={breadcrumbItems}/>
                    <div className={s.titleContainer}>
                        <h2><img className={s.titleImage} src={titleImage}/>{campaign.title}</h2>
                    </div>
                </div>
            </div>
            <div className={"row mt-5"}>
                <div className={"col-12 col-md-8"}>
                    <div className={s.cardContent}>
                        <ul className={s.article}>
                            <li>
                                <i className="fa fa-calendar"></i><a
                                href="https://dev.mightyaussie.com/blog/magazine/num01">
                                <time itemProp="datePublished" className="entry-date published"
                                      dateTime="2019-12-13T10:42:20+09:00"> {formatDate(campaign.published_at)}
                                </time>
                            </a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div className={"col-12 col-md-8"}>
                    {/*{campaign.banner && (*/}
                    {/*    <img*/}
                    {/*        src={campaign.banner}*/}
                    {/*        alt={campaign.name}*/}
                    {/*        className={s.cardImage}*/}
                    {/*    />*/}
                    {/*)}*/}

                    {/* custom css */}
                    <style>
                        {
                            (() => {
                                const decodedCss = decodeURIComponent(
                                        escape(
                                            atob(
                                                campaign.content.grapes_css || ""
                                            )
                                    )
                                )
                                   ;

                                const cleanedCss = decodedCss.replace(
                                    /body\s*\{[^}]*\}/gi,
                                    ""
                                );

                                return <style>{cleanedCss}</style>;
                            })()
                        }
                    </style>

                    {/* prefer html, fallback to description */}
                    {campaign.content.grapes_html? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html:  decodeURIComponent(
                                    escape(
                                        atob(
                                            campaign.content.grapes_html || ""
                                        )
                                    )
                                )
                            }}
                        />
                    ) : (
                        <div
                            className={s.description}
                            dangerouslySetInnerHTML={{
                                __html: campaign.meta_description
                            }}
                        />
                    )}
                </div>
                <div className={"col-12 col-md-4"}>
                    <Aside/>
                </div>
            </div>

        </>
    );
};

export default BlogView;